import React from 'react';
import type { MouseEvent } from 'react';

import { MediaTypeEnum } from 'modules/global/typing/enums/media.type.enum';
import type { ImageMedia as ImageMediaType } from 'modules/medias/types/image-media';
import type { VideoMedia as VideoMediaType } from 'modules/medias/types/video-media';

import type { MediaGalleryActions, MediaListItem } from '../../types';
import Actions from '../Actions';
import { Badge360, ImageThumbnailWrapper, PlayIconWrapper } from '../UI';

import Restrict from './Restrict';

type ImageMediaProps = {
  media: MediaListItem<ImageMediaType | VideoMediaType>;
} & MediaGalleryActions;

const ImageMedia: React.FC<ImageMediaProps> = ({ media, onRestrict, disabledOnRestrict, ...actions }) => {
  const { onPreview } = actions;
  const { isDuplicated } = media.data;
  const background = media.data.thumbnailPath || media.data.path;
  const is360 = media.data.type === MediaTypeEnum.IMAGE_INSIDE_360;

  const handleOnClick = React.useCallback((event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onPreview?.(media);
  }, [onPreview, media]);

  return (
    <React.Fragment>
      <ImageThumbnailWrapper background={background} onClick={handleOnClick} data-cy="media-gallery-tile">
        {media.data.type === MediaTypeEnum.VIDEO && (
          <PlayIconWrapper>
            <i className="fb-icon--play" />
          </PlayIconWrapper>
        )}
      </ImageThumbnailWrapper>
      <Actions media={media} {...actions} />
      {!isDuplicated && onRestrict && (
        <Restrict media={media} onRestrict={onRestrict} disabled={disabledOnRestrict} />
      )}
      {is360 && <Badge360 data-cy="flag-inside-360" className="fb-icon--panorama-photo-image" />}
    </React.Fragment>
  );
};

export default ImageMedia;
